module.exports = __webpack_public_path__ + "static/media/icon-time.0efa3dbb.svg";